import { useEffect } from 'react'

import { setDefaultFaviconEmoji } from 'utils/faviconUtils'
import { useBrand } from 'hooks/useBrand'

export const FaviconSetter = () => {
  const { favicon } = useBrand()

  useEffect(() => {
    setDefaultFaviconEmoji(favicon)
  }, [favicon])

  return null
}
